import { combineReducers } from 'redux';

import { LOGOUT } from 'actions/app.actions';
import app from './app.reducer';
import badge from './badge.reducer';
import challenges from './challenge.reducer';
import content from './content.reducer';
import notifications from './notifications.reducer';
import product from './product.reducer';
import widget from './widget.reducer';

const appReducer = combineReducers({
  app,
  badge,
  challenges,
  content,
  notifications,
  product,
  widget,
});

const rootReducer = (state: any, action: any): any => {
  if (action.type === LOGOUT) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
